import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./i18n";
import LanguageProvider from "./components/LanguageProvider";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import KnowledgeHub from "./pages/KnowledgeHub";
import Opportunities from "./pages/Opportunities";
import Join from "./pages/Join";
import Collaborate from "./pages/Collaborate";
import Professionals from "./pages/Professionals";
import Contact from "./pages/Contact";
import Events from "./pages/Events";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/house-of-wisdom" element={<KnowledgeHub />} />
            <Route path="/knowledge-hub" element={<Navigate to="/house-of-wisdom" replace />} />
            <Route path="/opportunities" element={<Opportunities />} />
            <Route path="/join" element={<Join />} />
            <Route path="/collaborate" element={<Collaborate />} />
            <Route path="/professionals" element={<Professionals />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/events" element={<Events />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
